import type { ChartColorToken } from "@salestrak/ui";

/**
 * The hue a widget family paints for items that own NO color of their own — a
 * person, a bucket, one unsplit trend line. Entity-colored items (a stage, a
 * type, a team) keep wearing their own color in every widget; this fills only
 * the gap where there is nothing to inherit, and without it every such widget
 * takes the head of the ramp and a whole dashboard comes out one hue.
 *
 * Read the map as a SET rather than as independent choices: these families sit
 * side by side on one board, so families that commonly share a board take
 * different hues and the board is varied with nothing for anyone to configure.
 * The hue belongs to the FAMILY — the same widget is the same color on every
 * dashboard and stays that color when the board is reordered. A hue that moved
 * with board position would read as meaning and carry none.
 *
 * A form whose items are separated BY hue is not in here: pie wedges, battery
 * segments and a split line chart take the ramp, because there the color IS
 * the encoding and one flat accent would erase it.
 */
export const WIDGET_ACCENT = {
  /** Ranked workload bars — `dimension-bar`. */
  dimensionBar: "chart3",
  /** Member activity ranking — `most-active-users`. */
  mostActiveUsers: "chart2",
  /** One unsplit trend line — `series-line`. */
  seriesLine: "chart1",
} as const satisfies Record<string, ChartColorToken>;
